<template>
  <layout-login>
    <h2 class="invite-title">
      {{ $t('message["471"]') }}<span
        class="invite-company"
      >
        <template v-if="projectname">
          {{ comname }}-{{ projectname }}
        </template>
        <template v-else>
          {{ comname }}
        </template>
      </span>
    </h2>
    <div>
      <cube-form
        :model="model"
        :options="options"
        @validate="validateHandler"
        @submit.prevent="submitHandler"
      >
        <cube-form-item :field="fields[0]" />
        <div class="cube-form-item-box">
          <cube-form-item :field="fields[1]" />
          <div class="find-pwd-box">
            <get-code
              class="find-pwd-link"
              :mobile="model.mobile"
              type="10"
              :is-disabled="sDisabled"
              @getRes="getCode"
            />
          </div>
        </div>
        <cube-form-group>
          <cube-button
            type="submit"
            :disabled="sDisabled"
            :primary="true"
          >
            {{ $t('message["597"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </layout-login>
</template>

<script type="text/ecmascript-6">
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import GetCode from '@/components/mobile/GetCode'
import { mapActions } from 'vuex'
import { loginFields, options } from '@/components/mobile/invite/common'
export default {
  components: {
    LayoutLogin,
    GetCode
  },
  data () {
    return {
      isValid: false,
      sDisabled: true,
      model: {
        mobile: '',
        checkcode: ''
      },
      options,
      fields: loginFields,
      inviteLogin: {
        checkuserid: '',
        isreg: 0,
        invitecode: this.$route.query.invitecode
      }
    }
  },
  computed: {
    comname () {
      return this.$route.query.comname
    },
    projectname () {
      return this.$route.query.projectname
    }
  },
  methods: {
    ...mapActions('team/invite', ['fetchLoginOrRegisterInvite']),
    async submitHandler (e) {
      const _this = this
      if (this.isValid) {
        let params = Object.assign(this.model, this.inviteLogin)
        const chain = await this.fetchLoginOrRegisterInvite(params)
        chain.onFail((err, all) => {
          console.log(err)
          const { payload } = all
          _this.$selefToast({ type: 'error', text: payload[0]['message'] })
        })
          .fetch()
      }
    },
    getCode (result) {
      this.inviteLogin.checkuserid = result.checkuserid
    },
    validateHandler (result) {
      const { valid } = result
      console.log(result)
      this.isValid = valid
      this.sDisabled = !this.isValid
    }
  }
}
</script>

<style scoped lang="scss">
.invite-title {
  width: 279px;
  margin: 30px auto;
}
.invite-title, .invite-company {
  color: #333;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  .invite-company {
    margin: 0 5px;
  }
}
</style>
